export default __webpack_public_path__ + "static/media/gallery_07.49e7430e.jpg";